import React from 'react';
import pluralize from 'pluralize';

import { registerSocket } from 'services/socket';

import MenuAlert from './menu-alert';


export default class InvoiceMenuAlert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.deregisterSocket = registerSocket('invoiceStatus', (message) => {
      this.setState({ ...message });
    });
  }
  
  componentWillUnmount() {
    this.deregisterSocket('invoiceStatus');
  }

  render() {
    const ach = Number(this.state.ach || 0);
    const email = Number(this.state.email || 0);
    const mail = Number(this.state.mail || 0);
    const total = ach + mail + email;

    if (total <= 0) return null;

    const title = (
      <div>
        { !!email && <span>{email} {pluralize('invoice', email)} ready to be emailed</span> }
        { !!(email && mail) && <br /> }
        { !!mail && <span>{mail} {pluralize('invoice', mail)} ready to be mailed</span> }
        { !!(email || mail) && !!ach && <br /> }
        { !!ach && <span>{ach} {pluralize('invoice', ach)} ready for ACH processing</span> }
      </div>
    );

    return (
      <MenuAlert title={title} className="badge-danger">
        {total}
      </MenuAlert>
    );
  }
}
